<template>
  <layout-basic>
    <page-hero
      title="Security & GDPR"
      lead="How IMPROVE protects your people data and supports compliance."
    />

    <section class="security-intro">
      <v-container>
        <div class="security-intro__copy">
          <p>
            Growing businesses need a learning platform they can trust with
            employee information. IMPROVE is designed with practical security
            controls and GDPR-aware practices so you can focus on training your
            people with confidence.
          </p>
        </div>
      </v-container>
    </section>

    <point-grid :points="points" :columns="2" tint />

    <section class="security-privacy">
      <v-container>
        <p class="security-privacy__copy">
          For full details on how we collect and process personal data, please
          read our
          <router-link to="/privacy-policy">Privacy Policy</router-link>.
        </p>
      </v-container>
    </section>

    <standard-cta />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'SecurityGdpr',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    StandardCta,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Security & GDPR | IMPROVE',
      description:
        'How IMPROVE protects your people data and supports GDPR compliance.',
      path: '/security-gdpr',
    });
  },
  data() {
    return {
      points: [
        'UK-based support team',
        'GDPR-aware data practices',
        'Secure access controls for managers and learners',
        'Clear data processing commitments',
        'Privacy Policy available for full transparency',
        'Designed for growing businesses that take compliance seriously',
      ],
    };
  },
};
</script>

<style scoped>
.security-intro {
  padding: 8px 0 16px;
}

.security-intro__copy {
  max-width: 720px;
  margin: 0 auto;
  color: var(--brand-navy, #002458);
  font-size: 17px;
  line-height: 1.6;
  text-align: center;
}

.security-intro__copy p {
  margin: 0;
}

.security-privacy {
  padding: 24px 0 40px;
  text-align: center;
}

.security-privacy__copy {
  max-width: 560px;
  margin: 0 auto;
  color: var(--brand-grey, #6b7280);
  font-size: 16px;
  line-height: 1.5;
}

.security-privacy__copy a {
  color: var(--brand-teal, #08a0a8);
  font-weight: 700;
  text-decoration: none;
}

.security-privacy__copy a:hover {
  text-decoration: underline;
}
</style>
